class ShopBenefits extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const content = this.querySelector('[data-content]');
    if (!content) return;

    // Convert any ul/li elements to match design
    const lists = content.querySelectorAll('ul');
    lists.forEach(list => {
      list.classList.add('grid', 'grid-cols-2', 'gap-y-1.5', 'pb-4');
      
      const items = list.querySelectorAll('li');
      items.forEach(item => {
        item.classList.add('flex', 'items-start', 'gap-x-2', 'text-red', 'sm-title');
        
        // Add tick icon before text
        const tick = document.createElement('span');
        tick.classList.add('flex');
        tick.innerHTML = `
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4L4 7L7.5 1" stroke="#B80D2B" stroke-width="0.5"/>
          </svg>
        `;
        item.insertBefore(tick, item.firstChild);
      });
    });
  }
}

customElements.define('shop-benefits', ShopBenefits);
